import { FC } from 'react'

const NotFound: FC = () => {
  return <div className="w-full mt-48 flex justify-center items-center text-white">404 - PAGE NOT FOUND :(</div>
}

export default NotFound
